import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import Swal from 'sweetalert2'
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare var iziToast:any;
declare var $:any;

@Component({
  selector: 'app-startservice',
  templateUrl: './startservice.component.html',
  styleUrls: ['./startservice.component.css']
})
export class StartserviceComponent implements OnInit {
  status_value: any=[];
  status_value_data: any;
  add_confiq :FormGroup;
  val_type: any;

  constructor(private serverservice : ServerService) { 
    this.add_confiq = new FormGroup({
      'hostname' : new FormControl(null,Validators.required),
      'user_name' : new FormControl(null,Validators.required),
      'pass_word' : new FormControl(null,Validators.required),
     });
  }
  list_data;
  selectedPersonArray:any=[];
  sel_values:any;
  select_row: Set<number> = new Set<number>();
  checkedRows: any = [];
  confg_btn=false;
  websocket;
  ngOnInit(): void {
    // this.config_button();
    this.get_service_status();
  }
  clearSelection() {
    this.select_row.clear();
    this.selectedPersonArray = [];
    this.sel_values = ''; // Optionally, clear any display values
  }

  get_service_status(){
    let api_req:any = '{"services":"websocket1,websocket2,mrvoip,mcwebrtc"}';
    this.serverservice.get_service(api_req).subscribe((response:any)=>{
      console.log(response);
      if(response!=''){
        this.list_data = response;
      }
    })
  }

  start(val){
    console.log(this.sel_values);
    if(this.sel_values==''|| this.sel_values==undefined || this.sel_values=="undefined" ||this.sel_values ==null){
      iziToast.warning({
        message: "Please Select any services",
        position: 'topRight'
    });
    return false;
    }
    $("#add_config").modal("show")
    console.log(this.sel_values);
    var k = this.sel_values.split(',');
    for(var i=0;i<=k.length-1;i++){
      //console.log(k[i]);
      this.val_type=val
      var action;
      if(val=='start'){
        if(k[i]=='websocket1'){
          action = "startwebsocket1";
        }else if(k[i]=='websocket2'){
          action = "startwebsocket2";
        }else if(k[i]=='mrvoip'){
          action = "startmrvoip";
        }else if(k[i]=='mcwebrtc'){
          action = "startmcwebrtc";
        }
      }else if(val=='stop'){
        if(k[i]=='websocket1'){
          action = "stopwebsocket1";
        }else if(k[i]=='websocket2'){
          action = "stopwebsocket2";
        }else if(k[i]=='mrvoip'){
          action = "stopmrvoip";
        }else if(k[i]=='mcwebrtc'){
          action = "stopmcwebrtc";
        }
      }else{
        if(k[i]=='websocket1'){
          action = "restartwebsocket1";
        }else if(k[i]=='websocket2'){
          action = "restartwebsocket2";
        }else if(k[i]=='mrvoip'){
          action = "restartmrvoip";
        }else if(k[i]=='mcwebrtc'){
          action = "restartmcwebrtc";
        }
      }
      this.status_value.push(action);
      // var service_data =JSON.parse(action)
      // console.log(service_data.service_name);
      console.log(this.status_value);
    }
    console.log(this.status_value);
    this.status_value_data = this.status_value.map(x=>x).join(",");
    return false;
    let api_req:any='{"action":"services_datas","services_name":"'+this.sel_values+'","service_type":"'+val+'"}';
    this.serverservice.get_serves_status(api_req).subscribe((response:any)=>{
      //console.log(response);
      if(response.data!=''){
        iziToast.success({
          message: "Service Successfully "+val,
          position: 'topRight'
      });
      this.get_service_status();
      }
    })
  }

  submit(){
    var user_name = $("#user_name").val();
    var password = $("#pass_word").val();
    var hostname = $("#hostname").val();
    if(user_name==''||user_name==undefined||user_name==null||user_name=='undefined'||user_name=='null'){
      iziToast.warning({
        message: "Please enter your user name",
        position: 'topRight'
    });
    return false;
    }
    if(password==''||password==undefined||password==null||password=='undefined'||password=='null'){
      iziToast.warning({
        message: "Please enter your password",
        position: 'topRight'
    });
    return false;
    }
    if(hostname==''||hostname==undefined||hostname==null||hostname=='undefined'||hostname=='null'){
      iziToast.warning({
        message: "Please enter your port number",
        position: 'topRight'
    });
    return false;
    }
    let api_req:any ='{"service_name":"'+this.status_value_data+'", "host":"'+hostname+'", "username": "'+user_name+'", "password":"'+password+'"}';
      this.serverservice.get_service1(api_req).subscribe((response:any)=>{
      console.log(response);
      //console.log(response);
      if(response[0].status== 1){
      $("#add_config").modal("hide");
      $("#hostname").val('');
      $("#user_name").val('');
      $("#pass_word").val('');
      this.status_value=[''];
      this.add_confiq.reset();
      this.clearSelection()
      this.get_service_status();
      iziToast.success({
        message: "Service " +this.val_type+ " Successfully",
        position: 'topRight'
    });
      } else {
        iziToast.error({
          message: "Service Not " +this.val_type,
          position: 'topRight'
      });
      }
    })
  }
  
  addThisPersonToArray(person: any, event){
    console.log(person);
  if(this.select_row.has(person)) {
    this.select_row.delete(person);
    const index: number = this.selectedPersonArray.indexOf(person);
    if (index !== -1) {
        this.selectedPersonArray.splice(index, 1);
    }        
    
   }
   else {
     this.select_row.add(person);
     var result = this.list_data.map(id => id.service_name).join(',');
    var k = result.split(',')
    for(var i=0;i<=k.length;i++){
      if(k[i]==person){
        this.selectedPersonArray.push(person);
      }
    }
   }
   this.sel_values = this.selectedPersonArray.map(x=>x).join(",");
    console.log(this.selectedPersonArray)

  }
  isPersonSelected(person: any) {
    return this.select_row.has(person);
  }
}
